var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_866_14847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.044 5.28005C10.044 4.0643 10.6519 4.0643 11.2598 4.0643H11.9892C12.111 4.06593 12.2319 4.04315 12.3447 3.9973C12.4576 3.95144 12.5601 3.88344 12.6462 3.79732C12.7323 3.71119 12.8003 3.60868 12.8462 3.49584C12.892 3.383 12.9148 3.26212 12.9132 3.14033V1.99752C12.9132 1.87515 12.8889 1.754 12.8417 1.6411C12.7945 1.5282 12.7254 1.42579 12.6383 1.33983C12.5512 1.25387 12.4479 1.18607 12.3344 1.14036C12.2209 1.09464 12.0994 1.07193 11.977 1.07354L10.2507 1.04923C9.748 1.02979 9.24709 1.11965 8.78252 1.31262C8.31795 1.50559 7.90078 1.79706 7.55981 2.16693C7.21884 2.5368 6.96218 2.97625 6.80756 3.45495C6.65293 3.93365 6.60402 4.4402 6.6642 4.93964V6.70249H5.70376C5.4587 6.70249 5.22369 6.79983 5.05041 6.97311C4.87713 7.14639 4.77979 7.38141 4.77979 7.62646V8.76927C4.77979 9.01432 4.87713 9.24934 5.05041 9.42261C5.22369 9.59589 5.4587 9.69324 5.70376 9.69324H6.6642V16.2218C6.6642 16.3831 6.72825 16.5377 6.84225 16.6517C6.95625 16.7657 7.11086 16.8297 7.27208 16.8297H9.4726C9.62741 16.8204 9.77281 16.7523 9.87904 16.6393C9.98527 16.5263 10.0443 16.3769 10.044 16.2218V9.69324H11.1139C11.3589 9.69324 11.5939 9.59589 11.7672 9.42261C11.9405 9.24934 12.0378 9.01432 12.0378 8.76927V7.62646C12.0378 7.38141 11.9405 7.14639 11.7672 6.97311C11.5939 6.79983 11.3589 6.70249 11.1139 6.70249H10.044V5.28005Z",
    stroke: "#323232",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_866_14847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0206,
    height: 17.0206,
    fill: "white",
    transform: "translate(0.317871 0.416992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8c1a031aba9084058c5691794da894e6.svg";
export { ForwardRef as ReactComponent };